import { SET_AVOID_SEGMENT_PICKING, CANCEL_AVOID_SEGMENT_PICKING } from 'actions';

export const defaultAvoidSegmentPickingState = {
  active: false,
  status: 'idle',
  segment: null,
  direction: 'both',
  error: null,
  confirmed: null,
};

export default (state = defaultAvoidSegmentPickingState, { payload = {}, type }) => {
  switch (type) {
    case SET_AVOID_SEGMENT_PICKING:
      return { ...state, ...payload };
    case CANCEL_AVOID_SEGMENT_PICKING:
      return defaultAvoidSegmentPickingState;
    default:
      return state;
  }
};
